module.exports = __webpack_public_path__ + "img/sysjs.f3ac0dd5.png";